/**
 * Accessibility Improvements JavaScript
 * Handles ARIA attributes and keyboard navigation
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // ============= ACCORDION ACCESSIBILITY =============
  const accordionButtons = document.querySelectorAll('.accordion-button');
  
  accordionButtons.forEach(button => {
    button.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      const panelId = this.getAttribute('aria-controls');
      const panel = document.getElementById(panelId);
      
      // Toggle aria-expanded
      this.setAttribute('aria-expanded', !expanded);
      
      // Toggle panel visibility
      if (panel) {
        if (expanded) {
          panel.setAttribute('hidden', '');
        } else {
          panel.removeAttribute('hidden');
        }
      }
    });
    
    // Add keyboard support
    button.addEventListener('keydown', function(e) {
      // Enter or Space key
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });
  
  // ============= HAMBURGER MENU ACCESSIBILITY =============
  const hamburgerButton = document.getElementById('hamburger');
  
  if (hamburgerButton) {
    // Update aria-expanded when menu opens/closes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const isOpen = document.body.classList.contains('menu-open') || 
                        document.querySelector('.mobile-hamburger.active');
          hamburgerButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      });
    });
    
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }
  
  // ============= CART COUNT LIVE REGION =============
  const cartCount = document.querySelector('.js__ajax-cart-count');
  
  if (cartCount) {
    // Add live region for cart updates
    cartCount.setAttribute('aria-live', 'polite');
    cartCount.setAttribute('aria-atomic', 'true');
    
    // Update cart link aria-label when count changes
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const count = cartCount.textContent.trim();
          const cartLink = document.querySelector('.js__cart-expand');
          if (cartLink) {
            cartLink.setAttribute('aria-label', `Shopping Cart with ${count} items`);
          }
        }
      });
    });
    
    observer.observe(cartCount, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }
  
  // ============= SWIPER CAROUSEL KEYBOARD NAVIGATION =============
  const swiperButtons = document.querySelectorAll('[role="button"][aria-label*="product"], [role="button"][aria-label*="announcement"]');
  
  swiperButtons.forEach(button => {
    button.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });
  
  // ============= FOCUS MANAGEMENT FOR MODALS =============
  const modalTriggers = document.querySelectorAll('.js__quick-view-click');
  
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      // Store the trigger element for returning focus
      window.lastFocusedElement = this;
    });
  });
  
  // Return focus when modal closes
  const closeModalButtons = document.querySelectorAll('.modal__close, .popup-modal__close');
  
  closeModalButtons.forEach(button => {
    button.addEventListener('click', function() {
      if (window.lastFocusedElement) {
        window.lastFocusedElement.focus();
        window.lastFocusedElement = null;
      }
    });
  });
  
  // ============= SKIP NAVIGATION ENHANCEMENT =============
  const skipLink = document.querySelector('.skip-navigation');
  
  if (skipLink) {
    skipLink.addEventListener('click', function(e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.focus();
        target.scrollIntoView();
      }
    });
  }
  
});